module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.scriptLoaded) ? _c('article', {
    directives: [{
      name: "ds",
      rawName: "v-ds",
      value: ({
        id: _vm.articleId,
        title: _vm.articleTitle,
        postId: _vm.postId
      }),
      expression: "{id: articleId, title: articleTitle, postId: postId}"
    }],
    staticClass: "posts duoshuo",
    attrs: {
      "id": "duoshuo-comment"
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0555d758!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DuoShuo.vue
// module id = 73
// module chunks = 2